import { Helmet } from "react-helmet-async";
import { useHostname } from "@/lib/ssr";
import { isSoraEnabled } from "@/lib/siteFont";

// The site's faces, from Google Fonts, on the new home, /events, /personal and /personal/*: Inter (body) and the
// heading face. Linked from the page's <head> (server-rendered) so they start loading with the first byte; the
// site-wide @import in src/index.css loads the same families. Where the Sora headings are on (src/lib/siteFont.ts),
// DefaultMeta links Sora site-wide, so this links Inter only; otherwise Inter and Space Grotesk as before.
export const HOME_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@500;600;700&display=swap";
export const HOME_FONTS_URL_SORA = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap";

export const homeFontsUrl = (sora: boolean): string => (sora ? HOME_FONTS_URL_SORA : HOME_FONTS_URL);

const HomeFonts = () => {
  const href = homeFontsUrl(isSoraEnabled(useHostname()));
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link rel="stylesheet" href={href} />
    </Helmet>
  );
};

export default HomeFonts;
